// extracted by mini-css-extract-plugin
export default {"pagination":"pagination_pagination__10PCi","icon":"pagination_icon__Vo4lw","activePage":"pagination_activePage__cjndJ"};